const flatpickr = require('flatpickr/dist/flatpickr.js');
require('flatpickr/dist/l10n/nl.js');

const init = () => {
  const datepickerInputs = document.querySelectorAll('[data-js-bind="datepicker"]');
  
  if (!datepickerInputs.length) {
    return;
  }

  datepickerInputs.forEach((datepickerInput) => {
    const dateFormat = datepickerInput.dataset.dateFormat || 'j F Y';
    const minDate = datepickerInput.dataset.minDate || null;
    const maxDate = datepickerInput.dataset.maxDate || null;
    const disabledDays = datepickerInput.dataset.disabledDays || null;

    const config = {
      altInput: true,
      altFormat: dateFormat,
      dateFormat: 'Y-m-d',
      minDate: minDate,
      maxDate: maxDate,
      locale: 'nl',
      onChange: function(selectedDates, dateStr, instance) {
        const event = new Event('change', { bubbles: true });
        datepickerInput.dispatchEvent(event);
      }
    };

    if (disabledDays) {
      const daysToDisable = disabledDays.split(',').map(day => parseInt(day.trim(), 10));
      
      config.disable = [
        function(date) {
          return daysToDisable.includes(date.getDay());
        }
      ];
    }

    flatpickr(datepickerInput, config);
  });
};

init();

